
import axios from "axios";
import $utils from 'xe-utils'
/*
    工具目录:
    1.responsive → 动态计算屏幕中元素的高度
    参数实例 elementArray: [ // 所有需要计算高度的元素数组
        {
            parent: { // 父级元素对象(必传)
                element: element, // 元素(必传)
                proportion: Number || null, // 比例(可选)
                lineHeight: Number || null, // 行高(可选)
                line: Number || null, // 行数(可选)
                verticalCenter: true || null // 文字是否垂直居中(可选)
            },
            child: { // 子元素对象(可选)
                element: element, // 元素(必传)
                proportion: Number || null, // 比例(可选)
                verticalCenter: true || null // 是否相对父元素垂直居中(可选)
            }
        }
    ]

    2.addIndex → 数组对象添加序号
    参数实例 array: []

    3.inputArrayNullCheck → input内容空检查(数组)
    参数实例 array: [
        {
            value: input.value, // 被检查的input的value值
            prompt: '材料分类' // Input输入框的标题
        }
    ]
*/
import store from '../store'
import { inputNullCheck } from './inputCheck.js'
import el from "element-ui/src/locale/lang/el";
export function responsive(elementArray) {
    if (!elementArray || Object.prototype.toString.call(elementArray) !== '[object Array]') {
        console.error('工具函数(responsive): 参数不存在或参数类型错误!')
        return
    }

    elementArray.map(i => {
        if (Object.prototype.toString.call(i) !== '[object Object]') return

        i.parent.element.style.height = store.state.common.clientHeight * i.parent.proportion + 'px'

        if (i.parent.fontSize) {
            i.parent.element.style.fontSize = store.state.common.clientHeight * i.parent.fontSize + 'px'
        }
        if (i.parent.lineHeight) {
            i.parent.element.style.lineHeight = i.parent.lineHeight + 'px'
        }
        if (i.parent.verticalCenter) {
            i.parent.element.style.lineHeight = (store.state.common.clientHeight * i.parent.proportion)
                / (i.parent.line || 1) + 'px'
        }
        if (i.parent.paddingTop) {
            i.parent.element.style.paddingTop =
                ((store.state.common.clientHeight * i.parent.proportion) - (i.parent.lineHeight * i.parent.line)) / 2 + 'px'
        }
        if (i.child) {
            if (i.child.proportion) i.child.element.style.height = store.state.common.clientHeight * i.child.proportion + 'px'
            if (i.child.verticalCenter) {
                i.child.element.style.marginTop = (store.state.common.clientHeight * i.parent.proportion -
                    i.child.element.offsetHeight) / 2 + 'px'
            }
        }
    })
}

export function addIndex(array) {
    if (!array || Object.prototype.toString.call(array) !== '[object Array]') {
        console.error('工具函数(addIndex): 参数不存在或参数类型错误!')
        return
    }

    array.map((i, k) => {
        if (Object.prototype.toString.call(i) !== '[object Object]') return
        i.index = k + 1
    })
}

export function inputArrayNullCheck(array) {
    if (!array || Object.prototype.toString.call(array) !== '[object Array]' || array.length === 0) {
        console.error('工具函数(inputArrayNullCheck): 参数不存在或参数类型错误!')
        return
    }

    for (var i = 0; i < array.length; i++) {
        if (Object.prototype.toString.call(array[i]) !== '[object Object]') break
        if (inputNullCheck(array[i].value, array[i].prompt)) return true
    }

    return false
}

// 根据格式把时间转化成需要的字符串类型
export function dateFormat(dateTime, stringType) {
    let dateString
    let yearString = new Date(dateTime).getFullYear()
    let month = new Date(dateTime).getMonth() + 1
    let monthString
    let day = new Date(dateTime).getDay()
    let dayString
    month < 10 ? (monthString = '0' + month) : (monthString = month)
    day < 10 ? (dayString = '0' + day) : (dayString = day)

    switch (stringType) {
        case 'yyyy':
            dateString = yearString + ''
            break
        case 'yyyy-MM':
            dateString = yearString + '-' + monthString
            break
        case 'yyyyMM':
            dateString = yearString + '' + monthString
            break
        case 'yyyy-MM-dd':
            dateString = yearString + '-' + monthString + '-' + dayString
            break
    }

    return dateString
}

// 把时间转化成季度
export function quarterFormat(dateTime, returnType) {
    let quarterString
    let month = new Date(dateTime).getMonth() + 1

    if (returnType === 1) {
        switch (month) {
            case 1:
                quarterString = 1
                break
            case 4:
                quarterString = 2
                break
            case 7:
                quarterString = 3
                break
            case 10:
                quarterString = 4
                break
        }
    }
    if (returnType === 2) {
        switch (month) {
            case 1:
                quarterString = '一'
                break
            case 4:
                quarterString = '二'
                break
            case 7:
                quarterString = '三'
                break
            case 10:
                quarterString = '四'
                break
        }
    }

    return quarterString
}

// 判断数字
export function isRealNum(val) {
    if (val === "" || val == null) {
        return false
    }
    if (!isNaN(val)) {
        return true
    } else {
        return false
    }
}

export const isNumber = (o) => {
    return Object.prototype.toString.call(o).slice(8, -1) === 'Number'
}

// 判断邮箱
export function isEmail(val) {
    return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(val)
}

// 去重
export function distinct(a, b) {
    return Array.from(new Set([...a, ...b]))
}

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path)
}


// 导出Excel公用方法
export function exportExcel(url, params) {
    axios
        .post(url, params, {
            responseType: "arraybuffer",
            headers: {
                token: localStorage.getItem('access_token')
            },
        })
        .then((res) => {
            // 获取文件名  这里是后台使用了cache-control 放文件名称  Content-Disposition  axios不接受
            const fileName = decodeURI(
                res.headers['cache-control'].split('=')[1]
            )
            const link = document.createElement("a"); // 创建元素
            let blob = new Blob([res.data], {
                type: "application/vnd.ms-excel",
            });
            link.style.display = "none";
            link.href = URL.createObjectURL(blob); // 创建下载的链接
            //num++
            link.setAttribute("download", fileName); // 给下载后的文件命名
            document.body.appendChild(link);
            link.click(); // 点击下载
            document.body.removeChild(link); //  下载完成移除元素
            window.URL.revokeObjectURL(link.href); // 释放掉blob对象
        });
}


// 计算当前季度
export function getQuarter(date) {
    let nowMonth = date.getMonth()
    let nowQuarter = []
    if (nowMonth < 3) {
        nowQuarter = 1
    } else if (nowMonth < 6) {
        nowQuarter = 2
    } else if (nowMonth < 9) {
        nowQuarter = 3
    } else if (nowMonth < 12) {
        nowQuarter = 4
    }
    return nowQuarter
}


// 计算季度
export function computeQuarter() {
    let nowDate = $utils.now()
    nowDate = $utils.toDateString(nowDate, 'yyyy-MM-dd HH:mm:ss')
    let nowYear = new Date().getFullYear()
    let nowQuarter = null
    let handleYear = $utils.clone(nowYear, true)
    // 一季度 '04-06' 到 '07-05'
    let quarter1 = [nowYear + '-04-06 00:00:00', nowYear + '-07-05 23:59:59']
    let a1 = $utils.getDateDiff(quarter1[0], nowDate)
    let b1 = $utils.getDateDiff(nowDate, quarter1[1])
    if (a1.done && b1.done) {
        nowQuarter = 1
    }
    // 二季度 '07-06' 到 '10-05'
    let quarter2 = [nowYear + '-07-06 00:00:00', nowYear + '-10-05 23:59:59']
    let a2 = $utils.getDateDiff(quarter2[0], nowDate)
    let b2 = $utils.getDateDiff(nowDate, quarter2[1])
    if (a2.done && b2.done) {
        nowQuarter = 2
    }
    // 三季度 大于'10-06'  小于'01-05'
    let quarter3 = [nowYear + '-10-06 00:00:00', nowYear + '-01-05 23:59:59']
    let a3 = $utils.getDateDiff(quarter3[0], nowDate)
    let b3 = $utils.getDateDiff(nowDate, quarter3[1])
    if (a3.done || b3.done) {
        nowQuarter = 3
    }
    if (b3.done) {
        handleYear = handleYear - 1
    }
    // 四季度 '01-06' 到 '04-05'
    let quarter4 = [nowYear + '-01-06 00:00:00', nowYear + '-04-05 23:59:59']
    let a4 = $utils.getDateDiff(quarter4[0], nowDate)
    let b4 = $utils.getDateDiff(nowDate, quarter4[1])
    if (a4.done && b4.done) {
        nowQuarter = 4
        handleYear = handleYear - 1
    }
    let dataObj = {
        year: handleYear + '',
        quarter: nowQuarter
    }
    return dataObj
}
// 自定义季度 2
export function customQuarter() {
    let nowDate = $utils.now()
    nowDate = $utils.toDateString(nowDate, 'yyyy-MM-dd HH:mm:ss')
    let nowYear = new Date().getFullYear()
    let baseQuarter = parseInt((new Date().getMonth() + 1) / 3) + 1;
    let mon = new Date().getMonth() + 1;
    let nowQuarter = null
    let handleYear = $utils.clone(nowYear, true)
    // 一季度 '01-06' 到 '04-05'
    let quarter1 = [nowYear + '-01-06 00:00:00', nowYear + '-04-05 23:59:59']
    let a1 = $utils.getDateDiff(quarter1[0], nowDate)
    let b1 = $utils.getDateDiff(nowDate, quarter1[1])
    if (a1.done && b1.done) {
        nowQuarter = 1
    }
    // 二季度 '04-06' 到 '07-05'
    let quarter2 = [nowYear + '-04-06 00:00:00', nowYear + '-07-05 23:59:59']
    let a2 = $utils.getDateDiff(quarter2[0], nowDate)
    let b2 = $utils.getDateDiff(nowDate, quarter2[1])
    if (a2.done && b2.done) {
        nowQuarter = 2
    }
    let handleDate = new Date().getDate()
    if (baseQuarter == 4 && mon == 10 && handleDate <= 31) {
        // 三季度 大于'07-06'  小于'10-31'
        let quarter3 = [nowYear + '-07-06 00:00:00', nowYear + '-10-31 23:59:59']
        let a3 = $utils.getDateDiff(quarter3[0], nowDate)
        let b3 = $utils.getDateDiff(nowDate, quarter3[1])
        if (a3.done && b3.done) {
            nowQuarter = 3
        }
    } else {
        // 三季度 大于'07-06'  小于'10-05'
        let quarter3 = [nowYear + '-07-06 00:00:00', nowYear + '-10-05 23:59:59']
        let a3 = $utils.getDateDiff(quarter3[0], nowDate)
        let b3 = $utils.getDateDiff(nowDate, quarter3[1])
        if (a3.done && b3.done) {
            nowQuarter = 3
        }
    }
    // 四季度 '01-06' 到 '04-05'
    let quarter4 = [nowYear + '-11-01 00:00:00', nowYear + '-01-05 23:59:59']
    let a4 = $utils.getDateDiff(quarter4[0], nowDate)
    let b4 = $utils.getDateDiff(nowDate, quarter4[1])
    if (a4.done || b4.done) {
        nowQuarter = 4
    }
    if (b4.done) {
        handleYear = handleYear - 1
    }

    let dataObj = {
        year: handleYear + '',
        quarter: nowQuarter
    }
    return dataObj
}




// WEBPACK FOOTER //
// ./src/utility/toolFunction.js